import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type GetAttendEventsQuery =
  operations['AdminGroupEventController_getGroupEventList']['parameters']['query'];
type GetAttendEventsHeaders =
  operations['AdminGroupEventController_getGroupEventList']['parameters']['header'];

interface GetAttendEventsProps {
  query: GetAttendEventsQuery;
  headers?: OmitGroupIdInHeader<GetAttendEventsHeaders>;
}

type GetAttendEventsResponse = components['schemas']['List$GroupEvent$mZFLkyvTelC5g8XnyQrpOw'];

export async function getAttendEvents({
  query,
  headers,
}: GetAttendEventsProps): Promise<GetAttendEventsResponse | false> {
  const response = await authenticateRequest<GetAttendEventsResponse>({
    method: 'get',
    url: `/api/v1/admin/group-event`,
    headers,
    params: query,
  });

  console.log('getAttendEvents', { response });
  return response;
}

export type { GetAttendEventsQuery, GetAttendEventsResponse };
